import Box from '@zenbusiness/zui/Box';
import IconButton from '@zenbusiness/zui/IconButton';
import Menu from '@zenbusiness/zui/Menu';
import { superstyled } from '@zenbusiness/zui/styles';

export const UserMenuButton = superstyled({
  name: 'UserMenu',
  slot: 'Button',
  tag: IconButton,
  propsNeeded: ['open'],
  styles: ({ open, theme }) => ({
    color: theme.palette.primary.contrastText,

    [theme.breakpoints.up('md')]: {
      ...(open && {
        background: theme.palette.primary.main,
      }),

      ...(!open && {
        background: theme.palette.background.grey.dark,
        color: theme.palette.text.primary,

        '&:hover': {
          background: theme.palette.background.grey.darker,
        },
      }),
    },
  }),
});

export const UserMenuContainer = superstyled({
  name: 'UserMenu',
  slot: 'Container',
  tag: Menu,
  styles: ({ theme }) => ({
    paddingBlock: theme.spacing(1),
    width: '100%',
    maxWidth: theme.spacing(52.5), // 420px
  }),
});

export const UserMenuList = superstyled({
  name: 'UserMenu',
  slot: 'List',
  tag: Box,
  propsAdded: {
    component: 'ul',
  },
});
